const SPORTSHUB_SEARCH_FAMILIES = {"es":{"vests":{"terms":["chaleco running","chaleco hidratación","mochila hidratación"],"query":"chaleco running","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["botella flexible","botella plegable","bidón blando"],"query":"botella flexible","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["escurridor bidones","soporte secado","secador soft flask"],"query":"escurridor bidones","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["cinturón hidratación","cinturón running","riñonera"],"query":"cinturón hidratación","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["bolsa de agua","bolsa hidratación","vejiga hidratación"],"query":"bolsa de agua","ids":["10971177156945"]},"backpacks":{"terms":["mochila"],"query":"mochila","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["mochila trail"],"query":"mochila trail","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["mochila urbana"],"query":"mochila urbana","ids":["11176463794513"]},"quivers":{"terms":["bolsa bastones","bolsa para bastones","carcaj","carcaj para bastones","funda bastones","funda para bastones","porta bastones","porta-bastones","portabastones","quiver","pole bag","pole holder","pole quiver"],"query":"bolsa bastones","ids":["11142607831377","11143797801297","11143829946705"]}},"fr":{"vests":{"terms":["gilet hydratation","sac hydratation","gilet trail"],"query":"gilet hydratation","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["flasque souple","gourde pliable","gourde souple"],"query":"flasque souple","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["support séchage","égouttoir gourde","séchoir flasque"],"query":"support séchage","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["banane running","ceinture hydratation","ceinture running"],"query":"banane running","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["poche hydratation","poche à eau","réservoir hydratation"],"query":"poche hydratation","ids":["10971177156945"]},"backpacks":{"terms":["sac à dos"],"query":"sac à dos","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["sac trail"],"query":"sac trail","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["sac urbain"],"query":"sac urbain","ids":["11176463794513"]},"quivers":{"terms":["carquois","carquois batons","carquois bâtons","carquois pour bâtons","porta batons","porta bâtons","porta-batons","porta-bâtons","portabatons","portabâtons","porte batons","porte bâtons","porte-batons","porte-bâtons","quiver","sac a batons","sac à bâtons","pole bag","pole holder","pole quiver"],"query":"carquois","ids":["11142607831377","11143797801297","11143829946705"]}},"it":{"vests":{"terms":["zaino idrico","gilet trail","gilet idratazione"],"query":"zaino idrico","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["borraccia flessibile","borraccia morbida","borraccia pieghevole"],"query":"borraccia flessibile","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["scolabottiglie","supporto asciugatura","asciuga borracce"],"query":"scolabottiglie","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["cintura idratazione","cintura running","marsupio running"],"query":"cintura idratazione","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["sacca acqua","sacca idrica","serbatoio idratazione"],"query":"sacca acqua","ids":["10971177156945"]},"backpacks":{"terms":["zaino"],"query":"zaino","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["zaino trail"],"query":"zaino trail","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["zaino urbano"],"query":"zaino urbano","ids":["11176463794513"]},"quivers":{"terms":["faretra","porta bastoncini","porta-bastoncini","portabastoncini","quiver","sacca porta bastoncini","pole bag","pole holder","pole quiver"],"query":"faretra","ids":["11142607831377","11143797801297","11143829946705"]}},"de":{"vests":{"terms":["Trinkrucksack","Laufweste","Trinkweste"],"query":"Trinkrucksack","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["Faltflasche","flexible Trinkflasche","weiche Trinkflasche"],"query":"Faltflasche","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["Abtropfständer","Flaschentrockner","Trockenständer"],"query":"Abtropfständer","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["Hüfttasche","Laufgürtel","Trinkgürtel"],"query":"Hüfttasche","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["Trinkblase","Trinkreservoir","Wasserblase"],"query":"Trinkblase","ids":["10971177156945"]},"backpacks":{"terms":["Rucksack"],"query":"Rucksack","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["Trailrucksack"],"query":"Trailrucksack","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["Tagesrucksack"],"query":"Tagesrucksack","ids":["11176463794513"]},"quivers":{"terms":["Kocher fur Stocke","Köcher für Stöcke","quiver","Stockhalter","Stockkoecher","Stockköcher","pole bag","pole holder","pole quiver","Stocktasche"],"query":"Kocher fur Stocke","ids":["11142607831377","11143797801297","11143829946705"]}},"pt-pt":{"vests":{"terms":["colete trail","mochila hidratação","colete hidratação"],"query":"colete trail","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["bidão mole","garrafa dobrável","garrafa flexível"],"query":"bidão mole","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["escorredor garrafas","secador garrafas","suporte secagem"],"query":"escorredor garrafas","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["bolsa cintura","cinto corrida","cinto hidratação"],"query":"bolsa cintura","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["bolsa de água","bolsa hidratação","reservatório hidratação"],"query":"bolsa de água","ids":["10971177156945"]},"backpacks":{"terms":["mochila"],"query":"mochila","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["mochila trail"],"query":"mochila trail","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["mochila urbana"],"query":"mochila urbana","ids":["11176463794513"]},"quivers":{"terms":["bolsa para bastoes","bolsa para bastões","porta bastoes","porta bastões","porta-bastoes","porta-bastões","quiver","pole bag","pole holder","pole quiver"],"query":"bolsa para bastoes","ids":["11142607831377","11143797801297","11143829946705"]}},"nl":{"vests":{"terms":["drinkrugzak","drinkvest","hardloopvest"],"query":"drinkrugzak","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["flexibele drinkfles","opvouwbare drinkfles","zachte drinkfles"],"query":"flexibele drinkfles","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["drooghouder","droogrek","flessendroger"],"query":"drooghouder","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["drinkgordel","hardloopriem","heuptas"],"query":"drinkgordel","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["drinkreservoir","drinkzak","waterzak"],"query":"drinkreservoir","ids":["10971177156945"]},"backpacks":{"terms":["rugzak"],"query":"rugzak","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["trailrugzak"],"query":"trailrugzak","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["dagrugzak"],"query":"dagrugzak","ids":["11176463794513"]},"quivers":{"terms":["quiver","stokken houder","stokken-houder","stokkenhouder","stokkentas","pole bag","pole holder","pole quiver"],"query":"quiver","ids":["11142607831377","11143797801297","11143829946705"]}},"nb":{"vests":{"terms":["drikkesekk","drikkevest","løpevest"],"query":"drikkesekk","ids":["10755603235153","10770725405009","10447600976209","10619706736977","10447586361681","10620732342609","11005569794385","10317359972689","10346688905553","10447590424913","10770183946577","10447592096081","10363588542801","10447598387537","10447599141201","10447594815825","10666168484177","10447653667153","10694464536913","11005985063249","11099535769937","10447647113553","10770250858833","10641842307409","10447608807761","10622168105297","10447632236881","10770339725649","10447638233425","10770401296721","10757718704465","10730255515985","11005930733905","10722442084689","10757699141969"]},"flasks":{"terms":["myk drikkeflaske","myk flaske","sammenleggbar flaske"],"query":"myk drikkeflaske","ids":["10971471937873","10378980131153","10378983539025","10881423901009","10378995401041","10811487879505","11181318111569","11202362966353"]},"dryers":{"terms":["tørkeholder","tørkestativ","flasketørker"],"query":"tørkeholder","ids":["11181318111569","11202362966353","10886359843153","10886345064785","10886355681617","10733087457617","10886348996945","10886351651153"]},"belts":{"terms":["drikkebelte","hofteveske","løpebelte"],"query":"drikkebelte","ids":["10811369128273","10811372175697"]},"reservoir":{"terms":["drikkeblære","vannblære","væskeblære"],"query":"drikkeblære","ids":["10971177156945"]},"backpacks":{"terms":["ryggsekk"],"query":"ryggsekk","ids":["11176463794513","11176427389265","11134502306129","11134453055825"]},"trail_backpacks":{"terms":["løpesekk"],"query":"løpesekk","ids":["11176427389265","11134502306129","11134453055825"]},"daypacks":{"terms":["dagstursekk"],"query":"dagstursekk","ids":["11176463794513"]},"quivers":{"terms":["quiver","stav holder","stav-holder","stavholder","stavkogger","pole bag","pole holder","pole quiver","stavpose"],"query":"quiver","ids":["11142607831377","11143797801297","11143829946705"]}}};

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
      searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      return;
    }

    const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then(async (text) => {
        text = await this.completeFamilyResults(text, searchTerm).catch(() => text);
        if (searchTerm !== this.getQuery()) {
          searchDeferred?.resolve({ totalCount: 0 });
          return;
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);

        searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          searchDeferred?.reject(error);
          return;
        }
        searchDeferred?.reject(error);
        if (searchTerm === this.getQuery()) this.close();
        throw error;
      });
  }

  async completeFamilyResults(text, searchTerm) {
    const normalize = (value) => value.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim().replace(/\s+/g, ' ');
    const query = normalize(searchTerm);
    const dictionary = SPORTSHUB_SEARCH_FAMILIES[document.documentElement.lang.toLowerCase()];
    if (!dictionary || query.length < 3) return text;
    const groups = Object.values(dictionary).filter((group) => group.terms.some((term) => normalize(term).startsWith(query)));
    if (!groups.length) return text;
    const parser = new DOMParser();
    const result = parser.parseFromString(text, 'text/html');
    const section = result.querySelector('#shopify-section-predictive-search');
    const readItems = (root) => Array.from(root.querySelectorAll('#predictive-search-results-products-list > li')).map((node) => {
      const payload = node.querySelector('product-component')?.getAttribute('view-event-payload');
      try { return { id: String(JSON.parse(payload).product.id), node }; } catch { return null; }
    }).filter(Boolean);
    const original = readItems(result);
    const missing = groups.filter((group) => !original.some((item) => group.ids.includes(item.id)));
    if (!missing.length) return text;
    PredictiveSearch.familyMarkup ||= new Map();
    const supplemental = await Promise.allSettled(missing.map(async (group) => {
      const url = new URL(routes.predictive_search_url, location.origin);
      url.searchParams.set('q', group.query);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const key = `${document.documentElement.lang}:${url}`;
      if (!PredictiveSearch.familyMarkup.has(key)) {
        const promise = fetch(url, { signal: AbortSignal.timeout(2000) }).then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        }).catch((error) => { PredictiveSearch.familyMarkup.delete(key); throw error; });
        PredictiveSearch.familyMarkup.set(key, promise);
      }
      const doc = parser.parseFromString(await PredictiveSearch.familyMarkup.get(key), 'text/html');
      return { group, doc, items: readItems(doc).filter((item) => group.ids.includes(item.id)) };
    }));
    const additions = supplemental.filter((entry) => entry.status === 'fulfilled' && entry.value.items.length).map((entry) => entry.value);
    if (!additions.length) return text;
    const pool = [...original, ...additions.flatMap((entry) => entry.items)];
    const selected = [];
    const add = (item) => { if (item && selected.length < 10 && !selected.some((other) => other.id === item.id)) selected.push(item); };
    groups.forEach((group) => add(pool.find((item) => group.ids.includes(item.id))));
    // Keep the small matching families visible before unrelated native suggestions.
    groups.filter((group) => group.ids.length <= 10).forEach((group) => pool.filter((item) => group.ids.includes(item.id)).forEach(add));
    original.filter((item) => groups.some((group) => group.ids.includes(item.id))).forEach(add);
    original.forEach(add);
    additions.flatMap((entry) => entry.items).forEach(add);
    let list = result.querySelector('#predictive-search-results-products-list');
    if (!list) {
      const source = additions[0].doc.querySelector('#predictive-search-results-products-list');
      const container = source.parentElement.cloneNode(true);
      const wrapper = result.querySelector('#predictive-search-results-groups-wrapper');
      if (wrapper) wrapper.append(container);
      else {
        const newWrapper = additions[0].doc.querySelector('#predictive-search-results-groups-wrapper').cloneNode(false);
        newWrapper.append(container);
        section.querySelector('#predictive-search-results').prepend(newWrapper);
      }
      list = result.querySelector('#predictive-search-results-products-list');
    }
    list.replaceChildren(...selected.map((item, index) => {
      const node = item.node.cloneNode(true);
      node.id = `predictive-search-option-product-${index + 1}`;
      node.setAttribute('aria-selected', 'false');
      const link = node.querySelector('a[href]');
      const href = new URL(link.getAttribute('href'), location.origin);
      href.searchParams.delete('_pos');
      href.searchParams.delete('_psid');
      href.searchParams.delete('_ss');
      href.searchParams.set('_psq', searchTerm);
      link.setAttribute('href', href.pathname + href.search);
      return node;
    }));
    result.querySelector('#predictive-search-results-groups-wrapper')?.classList.remove('predictive-search__results-groups-wrapper--no-products');
    const count = result.querySelector('[data-predictive-search-live-region-count-value]');
    const total = Number(count.dataset.totalResults || 0) - original.length + selected.length;
    const resultsText = total === 1 ? count.dataset.shResultsOne : count.dataset.shResultsOther?.replace('__count__', String(total));
    const productsText = selected.length === 1 ? count.dataset.shProductsOne : count.dataset.shProductsOther?.replace('__count__', String(selected.length));
    count.dataset.totalResults = String(total);
    if (resultsText && productsText) count.textContent = `${resultsText}: ${productsText}`;
    return section.outerHTML;
  }


  getTotalResultCount() {
    return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
  }

  dispatchSearchUpdateEvent(query) {
    const { SearchUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent) return null;

    const deferred = SearchUpdateEvent.createPromise();
    this.dispatchEvent(
      new SearchUpdateEvent({
        search: { query },
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

